import {
    type ViewStyle,
    StyleSheet
} from "react-native";
import type {
    Mutable
} from "../../../../types";

const stylesheet = StyleSheet.create({
    container: {
        alignItems: "center",
        flexDirection: "row",
        minWidth: 0
    },
    text: {
        flexShrink: 1,
        minWidth: 0
    }
});

export const useStyles = ({
    spaces
}: {
    spaces: NCoreUIKit.ActivePalette["spaces"];
}) => {
    const styles = {
        container: {
            gap: spaces.spacingXs
        } as Mutable<ViewStyle>
    };

    return styles;
};
export default stylesheet;
